import { useTranslate } from '@tolgee/react'
import { CarrierType, CarrierVisitDirection } from '@yard/app/api'
import { FC } from 'react'
import { AllocationRulesDrawerHeader } from '../../../atoms/AllocationRules/AllocationRulesDrawerHeader'

interface Props {
  carrierName: string
  carrierType?: CarrierType
  carrierVisitDirection?: CarrierVisitDirection
  onCreateNewRule: () => void
  onImportFromLibrary: () => void
  onCopyFromVisit: () => void
}
export const CarrierVisitRulesDrawerHeader: FC<Props> = props => {
  const {
    carrierName,
    carrierVisitDirection,
    carrierType,
    onCreateNewRule,
    onImportFromLibrary,
    onCopyFromVisit,
  } = props
  const { t } = useTranslate()

  return (
    <AllocationRulesDrawerHeader
      title={carrierName}
      overTitle={
        carrierVisitDirection === CarrierVisitDirection.Outbound
          ? t('outboundPlan', 'Outbound plan')
          : t('inboundPlan', 'Inbound plan')
      }
      carrierType={carrierType}
      onCreateNewRule={onCreateNewRule}
      onImportFromLibrary={onImportFromLibrary}
      onCopyFromVisit={onCopyFromVisit}
    />
  )
}
